import React, { useRef } from 'react';
import useTooltip from 'shared/lib/useTooltip';
import DoubleClickTooltip from 'fantastic/components/common/DoubleClickTooltip';

const Column = ({ number }) => {
  const [triggerRef, tooltip] = useTooltip(<DoubleClickTooltip />);

  return (
    <>
      {tooltip}
      <div className="fantastic-tool" ref={triggerRef}>
        {[...Array(number)].map((_, i) => (
          <div key={i} className="fantastic-tool__column" />
        ))}
      </div>
    </>
  );
};

export default Column;
